var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0029 0C10.1797 0 10.3493 0.0702609 10.4743 0.195316C10.5993 0.320301 10.6696 0.489853 10.6696 0.666649C10.6696 0.843446 10.5993 1.013 10.4743 1.13798L1.14093 10.4713C0.972895 10.6415 0.726579 10.7086 0.495447 10.6472C0.264315 10.5858 0.0837893 10.4053 0.0223724 10.1741C-0.0390444 9.94301 0.0280597 9.69669 0.198222 9.52865L9.53156 0.195316C9.65654 0.0702609 9.8261 0 10.0029 0ZM2.50813 4.50519C3.6127 4.50519 4.50813 3.60976 4.50813 2.50519C4.50813 1.40062 3.6127 0.505189 2.50813 0.505189C1.40357 0.505189 0.508135 1.40062 0.508135 2.50519C0.50934 3.60926 1.40407 4.50398 2.50813 4.50519ZM2.50814 1.83852C2.87632 1.83852 3.1748 2.137 3.1748 2.50519C3.1748 2.87338 2.87632 3.17186 2.50814 3.17186C2.13995 3.17186 1.84147 2.87338 1.84147 2.50519C1.84171 2.1371 2.14005 1.83877 2.50814 1.83852ZM6.16439 8.16144C6.16439 7.05687 7.05982 6.16144 8.16439 6.16144C9.26846 6.16265 10.1632 7.05737 10.1644 8.16144C10.1644 9.26601 9.26896 10.1614 8.16439 10.1614C7.05982 10.1614 6.16439 9.26601 6.16439 8.16144ZM8.16439 8.82811C7.7962 8.82811 7.49772 8.52963 7.49772 8.16144C7.49772 7.79325 7.7962 7.49478 8.16439 7.49478C8.53258 7.49478 8.83106 7.79325 8.83106 8.16144C8.83081 8.52953 8.53248 8.82786 8.16439 8.82811Z",
    fill: "#2E5DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.4bae5dc5b63ff41de1155ab9a297cd59.svg";
export { ForwardRef as ReactComponent };